<script>
import { map, uniqueId } from "lodash";
import ObjectExpenditureTemplate from "@/components/tables/finance-template-object.vue";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  props: {
    prexcs: null,
    template: null,
    tableBusy: null,
    outcome: {
      type: Number,
    },
  },
  components: {
    ObjectExpenditureTemplate,
    Treeselect,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      oeBusy: false,
      availableAccountsConsist: "LEAF_PRIORITY",
      newData: [],
      fields: [
        {
          key: "action",
          label: " ",
          thStyle: { width: "1%" },
        },
        {
          key: "uacs",
          label: "UACS",
          sortable: true,
          thStyle: { width: "15%" },
        },
        {
          key: "prexcName",
          label: "DYNAMIC/PREXC/KRA",
          sortable: true,
          thStyle: { width: "67%" },
        },
        {
          key: "balance",
          sortable: true,
          thStyle: { width: "15%" },
        },
      ],
      selectedPrexc: null,
      expenditures: [],
      availableAccounts: [],
      addModal: false,
      accountLoading: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US");
    },
    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    showDtls(row) {
      row.item.rotateChevy = !row.item.rotateChevy;
      if (row.item.showDetails) {
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      } else {
        this.oeBusy = true;
        setTimeout(() => {
          this.fetchOE(row);
        }, 500);
        row.toggleDetails();
        row.item.showDetails = !row.item.showDetails;
      }
    },
    fetchOE(row) {
      this.$store
        .dispatch("financeTemplate/getTemplateExpenditures", {
          financeTemplateId: this.template,
          prexcId: row.item.id,
        })
        .then((response) => {
          this.prexcs.find(
            (item) => item.id === row.item.id
          ).expenditures = response.data.map((item) => ({
            ...item,
            deliveryUnits: [],
            showDetails: false,
            rotateChevy: false,
          }));
          this.oeBusy = false;
        })
        .catch(() => {
          this.oeBusy = false;
          this.showToast("Error fetching expenditures", "error");
        });
      /** Fetch and display template OR here */
    },

    deleteItem(row) {
      this.$emit("deleteItem", row);
    },
    deleteOE(row) {
      this.prexcs
        .find((item) => item.id === row.prexcId)
        .expenditures.splice(
          this.prexcs.find((item) => item.id === row.prexcId).expenditures.indexOf(row),
          1
        );
    },
    addNew(id) {
      this.addModal = true;
      this.accountLoading = true;
      this.selectedPrexc = id;
      setTimeout(() => {
        this.getAvailableAccounts(id);
      }, 500);
    },
    getAvailableAccounts(id) {
      this.$store
        .dispatch("financeTemplate/getAvailableAccounts", {
          financeTemplateId: this.template,
          prexcId: id,
        })
        .then((response) => {
          this.availableAccounts = map(response.data, (item) => ({
            id: uniqueId("fc_"),
            label: item.classification,
            children: item.accountGroups.map((group) => ({
              id: uniqueId("ag_"),
              label: `${group.groupName} - (${group.accountType})`,
              children: group.accounts.map((account) => ({
                id: account.id,
                label: account.accountName,
              })),
            })),
          }));
          this.accountLoading = false;
        })
        .catch((e) => {
          this.addModal = false;
          this.accountLoading = false;
          this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
        });
    },
    clear() {
      this.newData = [];
      this.addModal = false;
    },
    saveAccounts() {
      this.oeBusy = true;
      const data = this.newData.map((item) => ({
        financeTemplateId: this.template,
        prexcId: this.selectedPrexc,
        accountId: item,
      }));
      this.$store
        .dispatch("financeTemplate/createMultipleTemplateExpenditures", data)
        .then(() => {
          this.fetchOE({ item: { id: this.selectedPrexc } });
          this.oeBusy = false;
          this.showToast("Successfully added new accounts", "success");
          this.clear();
          this.addModal = false;
        })
        .catch(() => {
          this.oeBusy = false;
          this.showToast(
            "Something went wrong. Cannot save Object of Expenditures",
            "error"
          );
        });
    },
    updatePrexc(record) {
      let newRecord = JSON.parse(JSON.stringify(record));
      newRecord.outcome = this.outcome;
      this.$store
        .dispatch("financeTemplate/getFinanceExpenditureBalance", record.oe)
        .then((response) => {
          this.prexcs
            .find((data) => data.id === record.prexc)
            .expenditures.find((data) => data.id === record.oe).allocated = response.data;
          this.$emit("updatePrexc", newRecord);
        })
        .catch((error) => {
          this.showToast("Something went wrong. Cannot fetch PREXC balance", "error");
        });
    },
  },
  computed: {
    rows() {
      return this.prexcs.length;
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12 mb-3">
        <h5 class="card-title">PREXC List</h5>
      </div>
      <div class="col-lg-12">
        <div id="datatable_wrapper"
             class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length"
                   class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select class="form-select form-select-sm mx-1"
                                 v-model="perPage"
                                 size="sm"
                                 :options="pageOptions"></b-form-select>&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter"
                   class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <div class="row">
            <!-- table data -->
            <div class="col-lg-12">
              <div class="custom-table-responsive mb-1">
                <b-table class="table-bordered"
                         :items="prexcs"
                         :busy="tableBusy"
                         :fields="fields"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :sort-desc.sync="sortDesc"
                         :filter="filter"
                         :filter-included-fields="filterOn"
                         @filtered="onFiltered"
                         show-empty>
                  <template #empty="scope">
                    <div class="text-center">
                      <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                    </div>
                  </template>
                  <template #cell(uacs)="row">
                    <span class="badge rounded-pill bg-success">{{ row.item.uacs }}</span>
                  </template>
                  <template #table-busy>
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(classification)="row">
                    <p class="mb-0">
                      {{ row.item.prexcClassification.classification }}
                    </p>
                    <p class="mb-0 text-warning">
                      <small><b>{{ row.item.prexcClassification.priority }}</b></small>
                    </p>
                  </template>
                  <template #cell(balance)="row">
                    <span class="text-info">{{ formatCurrency(row.item.balance) }}</span>
                  </template>
                  <template #cell(action)="row">
                    <div class="d-flex align-items-center justify-content-center"
                         @click="showDtls(row)">
                      <i class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
                         :class="{
                           'rotate-90': row.item.rotateChevy,
                         }"></i>
                    </div>
                  </template>
                  <template #row-details="row">
                    <transition name="max-height">
                      <div class="card border border-info"
                           v-if="row.item.showDetails">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="card-header bg-transparent border-success mt-2">
                              <h5 class="my-0 text-info">
                                <i class="mdi mdi-bullseye-arrow me-3"></i>Object of
                                Expenditures
                              </h5>
                            </div>
                          </div>
                          <div class="col-md-6 text-end">
                            <b-button class="mt-3 me-3"
                                      size="sm"
                                      variant="primary"
                                      @click="addNew(row.item.id)">
                              <i class="bx bx-plus"></i> Add New
                            </b-button>
                          </div>
                        </div>

                        <div class="card-body">
                          <ObjectExpenditureTemplate v-if="row.item.expenditures"
                                                     :tableBusy="oeBusy"
                                                     :objectOfExpenditures="row.item.expenditures"
                                                     :template="template"
                                                     :prexc="row.item.id"
                                                     @deleteItem="deleteItem"
                                                     @deleteOE="deleteOE"
                                                     @updatePrexc="updatePrexc" />
                        </div>
                      </div>
                    </transition>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- table data -->
          </div>
          <div class="row mt-3">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage"
                                :total-rows="rows"
                                :per-page="perPage">
                  </b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="addModal"
             size="lg"
             title="Select accounts"
             no-close-on-backdrop>
      <div v-if="accountLoading">
        <b-spinner small></b-spinner>
        <span class="ms-2">Loading...</span>
      </div>
      <div class="row"
           v-else>
        <treeselect :multiple="true"
                    :options="availableAccounts"
                    :value-consists-of="availableAccountsConsist"
                    :disable-branch-nodes="true"
                    :limit="5"
                    :max-height="300"
                    v-model="newData"
                    :clearOnSelect="true" />
      </div>
      <template #modal-footer>
        <b-button variant="primary"
                  @click="saveAccounts"> Save </b-button>
        <b-button variant="link"
                  @click="clear"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<style>
.vue-treeselect__label {
  font-size: 16px !important;
  font-weight: 300;
  color: #fff;
}

.vue-treeselect__control {
  background-color: #2a3042;
}

.vue-treeselect__menu {
  background-color: #2a3042;
}

.vue-treeselect__option--highlight {
  background-color: #2a3042;
}

.vue-treeselect__input {
  color: #fff;
}
</style>
